import axios from 'axios';

const baseURL = () => {
  const baseUrl = `${process.env.VUE_APP_QTEAM_API}`;
  return baseUrl;
};

const api = axios.create({
  baseURL: baseURL(),
  timeout: 360000,
});

export {
  api,
};
